import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCardLayoutMedium20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconCardLayoutMedium20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 5.5H6v4H2.5v-3a1 1 0 0 1 1-1m4 4v-4H12v4zm6 0h4v-3a1 1 0 0 0-1-1h-3zM2.5 11v2.5a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V11zM19 11v2.5a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 1 13.5v-7A2.5 2.5 0 0 1 3.5 4h13A2.5 2.5 0 0 1 19 6.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCardLayoutMedium20);
